module.exports = __webpack_public_path__ + "static/media/img-about-tablet.496f348d.jpg";